<template>
  <div class="row ma-0 align-center" style="justify-content: space-between">
    <span class="py-2">{{ getTitle(cell) }}</span>
    <v-switch v-model="input[cellKey]" hide-details label-left class="mt-0 ml-4" @change="(v) => $emit('change', v, cellKey)" />
  </div>
</template>

<script>
import { getTitle } from './wb-common';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
  created() {
    //Initialize with false
    if (!this.input[this.cellKey]) {
      this.$set(this.input, this.cellKey, false);
    }
  },
  computed: {
    cellKey() {
      return String(this.cell.key + this.mIndex);
    },
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
  },
};
</script>
